import { render } from "./mechanic.vue?vue&type=template&id=8717dd9e&ts=true"
import script from "./mechanic.vue?vue&type=script&lang=ts"
export * from "./mechanic.vue?vue&type=script&lang=ts"

import "./mechanic.vue?vue&type=style&index=0&id=8717dd9e&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__